import { useMemberExtract } from 'contexts/MemberExtract';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatMiles } from '../../../helpers/format';

function Header() {
  const { t } = useTranslation('card');

  const { memberExtract } = useMemberExtract();

  const status = memberExtract.status?.toLocaleLowerCase() || 'inactive';

  const plan = memberExtract.currentPlan && memberExtract?.memberExtractList[0]?.accumulatedMiles;

  return (
    <div className="corporate-club-extract__card__header">
      <h3 className="corporate-club-extract__card__header__title">
        <span className="corporate-club-extract__card__header__title__icon" />

        <span>
          {plan ? (
            <div>
              {t('planClub')} <span className="card-header-bold">Clube {formatMiles(plan)}</span>
            </div>
          ) : (
            t('card:smilesClub')
          )}
        </span>
      </h3>
      <div className="corporate-club-extract__card__header__status">
        <span
          className={`corporate-club-extract__card__header__status__icon corporate-club-extract__card__header__status__icon--${status}`}
        />
        <p className="corporate-club-extract__card__header__status__text">
          <strong>{t('status')}:</strong> <span>{t(status)}</span>
        </p>
      </div>
    </div>
  );
}

export default Header;
